/** Lower-case alphabetic label for an item nested inside one question. */
export function subitemLabel(index: number): string {
  if (index < 0) throw new Error('A sub-item index cannot be negative.')

  let label = ''
  let value = index
  while (true) {
    const remainder = value % 26
    label = String.fromCharCode(97 + remainder) + label
    value = Math.floor(value / 26)
    if (value === 0) return label
    value -= 1
  }
}
